<template>
    <div class="main">
        <h1 class="title">订单详情</h1>
        <div class="order-info-box">
            <div class="line-box">
                <label-text class="fl" label="订单编号：" :content="orderInfo.orderNum"></label-text>
                <label-text class="fl" label="下单时间：" :content="orderInfo.createTime | date"></label-text>
                <label-text class="fl" label="订单状态：" color="#FF5B4C" :content="orderInfo.blanketOrderStatus | payType"></label-text>
                <div class="clear"></div>
            </div>
            <div class="line-box">
                <label-text class="fl" label="下单账户：" :content="orderInfo.purchaser"></label-text>
                <label-text class="fl" label="订单金额：" :content="orderInfo.blanketOrderAmount | price('￥')"></label-text>
                <label-text class="fl" label="实付金额：" color="#FF5B4C" :content="orderInfo.blanketOrderPayAmount | price('￥')"></label-text>
                <div class="clear"></div>
            </div>
            <div class="line-box">
                <label-text class="fl" label="支付时间：" :content="orderInfo.payTime | date"></label-text>
                <label-text class="fl" label="发货时间：" :content="'-'"></label-text>
                <label-text class="fl" label="完成时间：" :content="'-'"></label-text>
                <div class="clear"></div>
            </div>
            <div class="line-box">
                <!--<label-text class="fl" label="发货商：" color="#2479ED" :content="'京东'"></label-text>-->
                <label-text class="fl" label="快递费：" :content="orderInfo.freight | fixed"></label-text>
                <div class="clear"></div>
            </div>
        </div>
        <div class="flex">
            <div class="order-info-box flex-1">
                <p class="second-title">收货人信息</p>
                <label-text class="margin-top-15" label="收货人：" :content="orderInfo.reciver"></label-text>
                <label-text class="margin-top-15" label="收货人电话：" :content="orderInfo.reciverMobile"></label-text>
                <label-text class="margin-top-15" label="收货人地址：" width="100%"
                            :content="orderInfo.address"></label-text>
            </div>
            <!--<div class="order-info-box flex-1" style="margin-left: 10px">-->
                <!--<p class="second-title">收货人信息</p>-->
                <!--<label-text class="margin-top-15" label="快递公司：" :content="'-'"></label-text>-->
                <!--<label-text class="margin-top-15" label="快递单号：" :content="'-'"></label-text>-->
            <!--</div>-->
        </div>
        <div class="order-info-box" v-for="(childOrder) in orderInfo.childOrderInfo" :key="childOrder.childOrderNum">
            <p class="second-title">商品列表-<span>{{childOrder.source === 0 ? '自营发货' : '京东发货'}}</span></p>
            <button v-if="childOrder.childOrderStatus === 1 && childOrder.source === 0" class="deliver-button"
                    @click="showDeliverModel(childOrder.childOrderNum)">发货</button>
            <div class="line-box">
                <label-text class="fl" label="子订单编号：" :content="childOrder.childOrderNum"></label-text>
                <label-text class="fl" label="发货时间：" :content="childOrder.expressageTime | date"></label-text>
                <div class="clear"></div>
            </div>
            <div class="line-box">
                <label-text class="fl" label="快递公司：" :content="orderInfo.expressageCompany || '-'"></label-text>
                <label-text class="fl" label="快递单号：" :content="orderInfo.expressageNum || '-'"></label-text>
                <div class="clear"></div>
            </div>
            <table class="table">
                <thead>
                <tr>
                    <td width="200px">商品图片</td>
                    <td>国际码</td>
                    <td width="200px">商品名称</td>
                    <td>单价</td>
                    <td>商品数量</td>
                    <td>合计金额</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="{good,key} in childOrder.goodsList" :key="key">
                    <td><img class="img" :src="good.img | img"/></td>
                    <td v-text="good.skuId"></td>
                    <td v-text="good.name">商品名称</td>
                    <td>{{good.price | price('￥')}}</td>
                    <td v-text="good.num"></td>
                    <td>{{good.price * good.num | price('￥')}}</td>
                </tr>
                </tbody>
            </table>
            <div class="total-box">
                <label-text class="fr" width="180px" label="应付款：" color="#FF5B4C" :content="childOrder.childOrderAmount | price('￥')"></label-text>
                <!--<label-text class="fr" width="180px" label="运费：" :content="'￥0'"></label-text>-->
                <!--<label-text class="fr" width="180px" label="商品金额：" :content="childOrder.childOrderAmount | price('￥')"></label-text>-->
            </div>
        </div>
        <div class="logistics-model" v-show="logisticsModel" v-loading="loading">
            <div class="mask" @click="logisticsModel = false"></div>
            <div class="logistics-box">
                <h1 class="title">物流信息</h1>
                <div class="input-box">
                    <label class="label">快递公司：</label>
                    <input class="input fr" v-model="expressageCompany" placeholder="请输入"/>
                </div>
                <div class="input-box">
                    <label class="label">快递单号：</label>
                    <input class="input fr" v-model="expressageNum" placeholder="请输入"/>
                </div>
                <div class="button-box" align="center">
                    <button class="cancel" @click="logisticsModel = false">取消</button>
                    <button class="confirm" @click="setLogisticsInfo()">确认</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import LabelText from './components/LabelText.vue'
  import {getOrderDetail, setExpressage} from '@/api/shop'
  export default {
    name: "orderDetail",
    components: {
      LabelText
    },
    data() {
      return {
        list: [1, 2],
        logisticsModel: false,
        orderInfo: {},
        childOrderNum: '',
        company: '',
        loading: false,
        expressageCompany: '',
        expressageNum: ''
      }
    },
    filters:{
      fixed(price, num){
        if(!price){
          return '-'
        }
        return price.toFixed(num || 2)
      },
      img(imgStr){
        const imgList = JSON.parse(imgStr);
        return imgList[0];
      },
      payType(status){
        if(!status){
          return ''
        }
        switch (Number(status)) {
          case 1:
            return '待付款';
          case 2:
            return '待付款';
          case 3:
            return '待付款';
          case 4:
            return '待付款';
        }
      }
    },
    mounted(){
      const {orderId} = this.$route.query;
      console.log(orderId);
      this.getOrderDetail(orderId);
    },
    methods:{
      showDeliverModel(childOrderNum){
        this.childOrderNum = childOrderNum;
        this.logisticsModel = true;
      },
      getOrderDetail(orderNum){
        getOrderDetail(orderNum).then(res => {
          console.log(res.data)
          this.orderInfo = res.data

        })
      },
      setLogisticsInfo(){
        if(!this.expressageCompany){
          return  this.$message({
            type: 'error',
            message: '请填写快递公司'
          })
        }else if(!this.expressageNum){
          return  this.$message({
            type: 'error',
            message: '请填写快递单号'
          })
        }
        this.loading = true;
        const postData = {
          expressageCompany: this.expressageCompany,
          expressageNum: this.expressageNum,
          orderId: this.childOrderNum
        }

        setExpressage(postData).then(res => {
          this.logisticsModel = false;
          this.loading = false;
        }).catch(err=>{
          this.$message({
            type: 'error',
            message: '网络错误'
          })
          this.loading = false;
        })
      }
    }
  }
</script>

<style scoped lang="scss">
    .main {
        min-width: 900px;
    }

    .fl {
        float: left;
    }

    .fr{
        float: right;
    }

    .flex {
        display: flex;
    }

    .flex-1 {
        flex: 1;
    }

    .title {
        height: 62px;
        line-height: 62px;
        background: #ffffff;
        font-size: 16px;
        padding-left: 20px;
        color: #333333;
        font-weight: 600;
    }

    .second-title {
        color: #333333;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 20px;
    }

    .clear {
        clear: both;
    }

    .order-info-box {
        margin-top: 10px;
        background: #FFFFFF;
        padding: 20px 20px;
        position: relative;
    }

    .deliver-button{
        cursor: pointer;
        position: absolute;
        right: 20px;
        top: 25px;
        width: 80px;
        height: 32px;
        background: #2479ED;
        color: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
    }

    .margin-top-15 {
        margin-top: 15px;
    }

    .line-box {
        margin-bottom: 15px;
    }

    .table {
        margin-top: 20px;
        width: 100%;
        border: solid #E4E7EC 1px;
        text-align: center;
        border-collapse: collapse;
        font-size: 14px;
        thead {
            height: 35px;
            background: #FAFCFF;
            color: #333333;
            border-bottom: solid #E4E7EC 1px;
        }

        tbody {
            tr {
                color: #666666;
                height: 130px;
                width: 100%;
                border-bottom: solid #E4E7EC 1px;
                .img{
                    height: 87px;
                    width: 87px;
                }
            }
            tr:nth-child(2n) {
                background:#FAFCFF;
            }

        }
    }

    .total-box{
        height: 60px;
        line-height: 60px;
        border: solid #E4E7EC 1px;
        border-top: none;
    }

    .logistics-model{
        z-index: 999;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0,0,0,0.4);
        .mask{
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 100;
        }
        .logistics-box{
            z-index: 200;
            width: 478px;
            height: 248px;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            opacity: 1;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            top: calc(50% - 124px);
            .title{
                text-align: center;
                color: #303030;
                font-size: 16px;
            }
            .button-box{
                margin-top: 30px;
                button{
                    cursor: pointer;
                    width: 76px;
                    height: 34px;
                    border-radius: 8px 8px 8px 8px;
                    margin: 0 20px;
                    box-sizing: border-box;
                }
                .cancel{
                    background: #FFFFFF;
                    border: 1px solid #E0E0E0;
                    color: #646464;
                }
                .confirm{
                    background: #5189F7;
                    color: #FFFFFF;
                }
            }
            .input-box{
                height: 32px;
                padding: 0 80px;
                line-height: 32px;
                margin-bottom: 30px;
                .label{
                    color: #303030;
                    font-size: 16px;
                }
                .input{
                    padding: 0 10px;
                    width: 207px;
                    height: 32px;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #E2E2E2;
                }
            }
        }
    }

</style>
